import React from 'react';
import moment from "moment";



export const DateTimeFormatter = (props) => {
    //moment.tz.setDefault('America/Edmonton');
    const { value } = props;
    let text = '';

    if (value) {
        text = new Date(value.toString());
        text = moment(text).format('MM/DD/YYYY h:mm a');
    }

    return <span>{text}</span>;
};

export const DateFormatter = (props) => {
    //moment.tz.setDefault('America/Edmonton');
    const { value } = props;
    let text = '';

    if (value) {
        text = new Date(value.toString());
        text = moment(text).format('MM/DD/YYYY');
    }

    return <span>{text}</span>;
};
export const MMYYYYFormatter = (props) => {
    //moment.tz.setDefault('America/Edmonton');
    const { value } = props;
    let text = '';

    if (value) {
        text = new Date(value.toString());
        text = moment(text).format('MM/YYYY');
    }

    return <span>{text}</span>;
};